import { marker } from "@jsverse/transloco-keys-manager/marker";
import { RoleType } from "src/app/backend/models/role/role";
import { absoluteUrl } from "src/app/support/navigation";
import { NavigationBarItem } from "src/app/modules/bootstrap/bootstrap-components/navigation-bar/navigation-bar-item";
import { sntTranslate } from "src/app/support/translate";
import { UserService } from "src/app/services/user.service";
import { appState } from "src/app/core/state";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { COLORS_FOR_MODULES } from "src/app/support/colors";

export function getBotmasterNavigationBarMenu(
  _currentRoles: RoleType[],
  {
    userService,
    bootstrapService
  }: { userService: UserService; bootstrapService: BootstrapService }
): NavigationBarItem[] {
  const botItems: NavigationBarItem[] = [
    {
      icon: "fa-light fa-robot",
      title: sntTranslate(marker("Bot")),
      url: absoluteUrl("/bots"),
      disabled: false,
      params: {
        tenant: appState.tenantId!
      }
    }
  ];

  const fatturazioneItems: NavigationBarItem[] = [
    {
      icon: "fa-light fa-file-invoice-dollar",
      title: sntTranslate(marker("Fatturazione")),
      url: absoluteUrl("/fatturazione"),
      disabled: true,
      params: {
        tenant: appState.tenantId!
      }
    }
  ];

  const statisticheItems: NavigationBarItem[] = [
    {
      icon: "fa-light fa-chart-mixed",
      title: sntTranslate(marker("Statistiche")),
      url: absoluteUrl("/statistiche"),
      disabled: true,
      params: {
        tenant: appState.tenantId!
      }
    }
  ];

  return [
    {
      title: sntTranslate(marker("Bot")),
      icon: "fa-light fa-robot",
      url: absoluteUrl("/bots"),
      items: botItems,
      disabled: false,
      params: {
        tenant: appState.tenantId!
      },
      color: COLORS_FOR_MODULES.STATISTICS
    },
    {
      title: sntTranslate(marker("Fatturazione")),
      icon: "fa-light fa-file-invoice-dollar",
      url: absoluteUrl("/fatturazione"),
      items: fatturazioneItems,
      disabled: true,
      params: {
        tenant: appState.tenantId!
      },
      color: COLORS_FOR_MODULES.INVOICES
    },
    {
      title: sntTranslate(marker("Statistiche")),
      icon: "fa-light fa-chart-mixed",
      url: absoluteUrl("/statistiche"),
      items: statisticheItems,
      disabled: true,
      params: {
        tenant: appState.tenantId!
      },
      color: COLORS_FOR_MODULES.STATISTICS
    }
  ];
}
